export default __webpack_public_path__ + "static/media/Urs.c175093f.png";